export const namespace = 'auth';
export const LOG_OUT = `${namespace}/'LOG_OUT'`;

export const userLogout = () => ({
  type: LOG_OUT,
  payload: {}
})